export default __webpack_public_path__ + "static/186-c410dc73e4cd873994af5bacf7b20ee5.jpg";